import generatorTopBar from '@/assets/images/generator/generator-top-bar.png';
import { EditorTagIcon } from '@/components/Icons';
import { modelVersion, modelVersionStage } from '@jenmusic/jen-config';

export default function EditorHeader() {
  return (
    <div className="w-full flex mt-[-24px] relative">
      <EditorTagIcon className="ml-4" />
      <div className=" absolute left-[12px] top-[36px] text-[11px] scale-50 tracking-tighter flex gap-[10px]">
        <span>JEN</span>
        <span>{modelVersionStage}</span>
        <span>v{modelVersion}</span>
      </div>
      <div className="w-[500px] max-w-3xl mx-auto">
        <div
          className="relative h-[62px]"
          style={{
            background: `url(${generatorTopBar}) no-repeat`,
            backgroundSize: 'cover',
          }}
        />
      </div>
    </div>
  );
}
